import React, { useState, useRef, useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import MaterialTable, { MTableToolbar } from 'material-table';
import { Autocomplete } from '@material-ui/lab';
import Dialog from '@material-ui/core/Dialog';
import TeamData from 'services/dataService/TeamData';
import { localizationTable, options } from 'constants/table';
import {
  statusPeriodFinished,
  statusUser,
} from 'constants/status';
import {
  CardContent,
  Grid,
  Button,
  Typography,
  TextField,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Divider,
  Paper
} from '@material-ui/core';
import { exportToXlsx, exportToXlsxDisk } from 'helpers/reportExport';
import { VerticalAlignBottom, Search } from '@material-ui/icons';
import MenuBookOutlinedIcon from '@material-ui/icons/MenuBookOutlined';
import DeviceHubOutlinedIcon from '@material-ui/icons/DeviceHubOutlined';
import GroupOutlinedIcon from '@material-ui/icons/GroupOutlined';
import TrendingUpOutlinedIcon from '@material-ui/icons/TrendingUpOutlined';
import { useStyles } from './styles';
import { ReportCompanyData } from 'services/dataService';
import { toast } from 'react-toastify';
//import NotificationData from 'services/dataService/NotificationData';
import Tooltip from "@material-ui/core/Tooltip";

export default ({ fields, required }) => {
  const [status, setStatus] = useState(1);
  const [disableButton, setDisableButton] = React.useState(true);
  const [periodBoolean, setPeriodBoolean] = React.useState(2)
  const [periodFinished, setPeriodFinished] = useState(0);
  const [disableDescription, setDisableDescription] = useState(true);
  const [showConfirmation, setShowConfirmation] = React.useState(false);
  const [filter, setFilter] = useState('');
  const [disable, setDisable] = React.useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [summary, setSummary] = useState({
    requiredCourses: { total: 0, completed: 0 },
    trails: { total: 0, completed: 0 },
    trailUsers: { total: 0, completed: 0 },
    trailProgress: { total: 0, completed: 0 },
  });

  const RELATORIO_KEY = "RelatorioAcademicoDownload";
  const BLOCKED_TIME = 6;

  const history = useHistory();


  const handlePeriodFinishedChange = (value) => {
    setPeriodFinished(value);
  }

  const columnsField = fields.map(field => ({
    ...field,
    sorting: false
  }));


  const handleChange = (value) => {
    setStatus(value);
    handleFetch(value);
  }

  const { t } = useTranslation([
    'label',
    'toastify',
    'tables',
    'form',
    'button',
    'validation',
  ]);
  const { register, handleSubmit, control } = useForm();
  const tableRef = useRef();

  const classes = useStyles();


  const onSubmit = (data) => {

    setFilter(data.filter);
    setStatus(data.status);

    setDisableButton(true);

    tableRef.current.state.query.page = 0;
    tableRef.current.onQueryChange();
  };



  const exportActionType = {
    excel: (col, responseData, title) => {
      exportToXlsxDisk(col, responseData, title);
    },
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleFetch = async (status, periodFinished) => {
    try {
      const response = await ReportCompanyData.getAcademic({
        filter,
        status,
        periodFinished,
        isExport: true,
      });

      return response.data;
    } catch (err) {
      toast.error(
        "Não foi possível buscar os dados do relatório, tente novamente mais tarde."
      );
      return [];
    }
  };

  const handleFetchToXlsx = async (status, periodFinished, col) => {

    const fn = required
      ? ReportCompanyData.getRequiredAcademicToXlsx
      : ReportCompanyData.getAcademicToXlsx;


    const response = await fn({
      filter,
      status,
      periodFinished,
      isExport: true,
      columns: JSON.stringify(col),
    });
    return response.data;
  };

  const existeRelatorioParaBaixar = () => {
    const unblockTime = localStorage.getItem(RELATORIO_KEY);
    if (unblockTime) {
      const now = new Date().getTime();
      if (now >= parseInt(unblockTime)) {
        setDisable(false);
        localStorage.removeItem(RELATORIO_KEY);
      } else {
        setDisable(true);
        setTimeout(() => {
          setDisable(false);
          localStorage.removeItem(RELATORIO_KEY);
        }, parseInt(unblockTime) - now);
      }
    } else {
      setDisable(false);
    }
  };


  const customExport = useCallback(async (type) => {
    let unblockTimer;

    try {
      setDisableDescription(false);
      setDisable(true);

      const unblockTime = new Date().getTime() + BLOCKED_TIME * 60 * 1000;
      localStorage.setItem(RELATORIO_KEY, unblockTime.toString());

      toast.info(t('toastify:commons.toast_generatereport'));
      const filteredColumns = tableRef.current.props.columns.map(column => {
        const { tableData, ...rest } = column;
        return rest;
      });

      setShowConfirmation(true);

      unblockTimer = setTimeout(() => {
        setDisable(false);
        localStorage.removeItem(RELATORIO_KEY);
      }, BLOCKED_TIME * 60 * 1000);

      const exportResponse = await handleFetchToXlsx(
        status,
        periodFinished,
        filteredColumns
      );
      if (exportResponse?.alreadyProcessing) {
        toast.info(t('toastify:commons.toast_report_already_processing'));
        return;
      }
      toast.success(t('toastify:commons.toast_report_ready'));
    } catch (error) {
      if (unblockTimer) clearTimeout(unblockTimer);
      setDisable(false);
      localStorage.removeItem(RELATORIO_KEY);
      toast.error(t('toastify:commons.toast_report_generation_error'));
    } finally {
      handleClose();
    }
  }, [status, periodFinished]);


  const handleClickConfirmSave = () => {
    setShowConfirmation(false);
  };

  const handleNotificationClick = () => {
    history.push('/notification');
  };

  const updateSummary = (coursesCount, trailCount, trailUsersCount) => {

    const completedTrails = trailCount.filter(
      t => t.finished === t.totalCourses
    ).length;

    const totalUsers = trailUsersCount.reduce((acc, t) => acc + t.usersTotal, 0);
    const completedUsers = trailUsersCount.reduce((acc, t) => acc + t.usersFinished, 0);

    const totalEnrollments = trailCount.reduce((acc, t) => acc + t.totalCourses, 0);
    const completedEnrollments = trailCount.reduce((acc, t) => acc + t.finished, 0);

    const nextSummary = {
      requiredCourses: {
        total: coursesCount.total,
        completed: coursesCount.finished,
      },
      trails: {
        total: trailCount.length,
        completed: completedTrails,
      },

      trailUsers: {
        total: totalUsers,
        completed: completedUsers,
      },
      trailProgress: {
        total: totalEnrollments,
        completed: completedEnrollments,
      },
    };

    setSummary((prev) => {
      if (JSON.stringify(prev) === JSON.stringify(nextSummary)) {
        return prev;
      }
      return nextSummary;
    });
  };

  const getCompletionPercent = (completed, total) => {
    if (!total) return 0;
    return Math.round((completed / total) * 100);
  };

  return (
    <>
      <div className='notranslate'>
        <Dialog
          open={showConfirmation}
          onClose={() => setShowConfirmation(false)}
        >
          <DialogTitle style={{ fontSize: '22px', textAlign: 'center' }}>⚠️ Atenção</DialogTitle>
          <DialogContent style={{ textAlign: 'center' }}>
            <Typography variant="subtitle1" gutterBottom>
              Em alguns instantes o seu Relatório Acadêmico estará disponível em Notificações.
            </Typography>
            <Typography variant="subtitle1">
              Basta clicar em <b>Notificações</b> &rarr; <b>Ver todas</b>
            </Typography>
          </DialogContent>
          <DialogActions style={{ justifyContent: 'center' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleClickConfirmSave()}
              style={{ padding: '10px 50px' }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <MaterialTable
          title={
            disableDescription ? (
              <div style={{ marginTop: 15, marginBottom: 15 }}>
                <Typography variant="h6">
                  {t(
                    required
                      ? 'tables:reports.title_required_reports_academic'
                      : 'tables:reports.title_reports_academic'
                  )}
                </Typography>
                <Typography variant="subtitle2" style={{ fontSize: 12 }}>
                  Use os filtros de pesquisa para localizar: <br />
                  por nome do curso, nome do aluno, CPF, e-mail, status ou ano de conclusão do curso.
                </Typography>
              </div>
            ) : (
              `${t('tables:reports.title_reports_academic')}`
            )
          }
          tableRef={tableRef}
          columns={
            columnsField || [
              {
                title: `${t('tables:reports.academic.teams_column')}`,
                field: `name`,
                render: (rowData) => rowData.name,
              },
              {
                title: `${t('tables:reports.academic.users_column')}`,
                field: `count_students`,
                render: (rowData) => rowData.student_name,
              },
              {
                title: `${t('tables:reports.academic.email_column')}`,
                field: `student_email`,
                render: (rowData) => rowData.student_email,
              },
              {
                title: `${t('tables:reports.academic.created_at')}`,
                field: `created_at`,
                render: (rowData) => rowData.created_at,
              },
              {
                title: `${t('tables:reports.academic.cpf_column')}`,
                field: `student_cpf`,
                render: (rowData) => rowData.student_cpf,
              },
              {
                title: `${t('tables:reports.academic.courses_column')}`,
                sorting: false,
                field: `course_name`,
                render: (rowData) => rowData.course_name,
              },
              {
                title: `${t('tables:reports.academic.trails_column')}`,
                field: `trail_name`,
                render: (rowData) => rowData.trail_name,
              },
              {
                title: `${t('tables:reports.academic.certificate_date_column')}`,
                field: `count_trails`,
                render: (rowData) => rowData.count_trails,
              },
              {
                title: `${t('tables:reports.academic.last_login_column')}`,
                field: `last_course_access`,
                render: (rowData) => rowData.last_course_access,
              },
              {
                title: `${t('tables:reports.academic.grade_column')}`,
                field: `grade`,
              },
              {
                title: `${t('tables:reports.academic.finished_column')}`,
                field: `count_lessons_finished`,
                render: (rowData) => rowData.count_lessons_finished,
              },
              {
                title: `${t('tables:reports.academic.progress_column')}`,
                field: `percent_progress`,
                render: (rowData) => rowData.percent_progress,
              },
              {
                title: `${t('tables:reports.academic.observation_column')}`,
                field: `observation`,
                render: (rowData) => rowData.observation,
              },
            ]
          }
          data={async (query) => {
            try {
              const fn = required
                ? ReportCompanyData.getRequiredAcademic
                : ReportCompanyData.getAcademic;

              const response = await fn({
                page: query.page + 1,
                limit: query.pageSize,
                filter,
                status,
                periodFinished,
              });

              existeRelatorioParaBaixar();

              let { academic, currentPage, totalCount } = response.data;

              let coursesCount = response.data.coursesCount ?? { finished: 0, total: 0 };
              let trailCount = response.data.trailCount ?? [];
              let trailUsersCount = response.data.trailUsersCount ?? [];

              academic = academic?.map((academicElement) => {
                let customFields = {};


                if (academicElement?.custom_field_values) {
                  const formattedCustomFieldValue = JSON.parse(
                    academicElement?.custom_field_values
                  );

                  for (const field of formattedCustomFieldValue) {
                    customFields[field?.fieldName] = field?.fieldValue;
                  }
                }

                return { ...academicElement, ...customFields };
              });

              updateSummary(coursesCount, trailCount, trailUsersCount || []);

              return {
                data: academic,
                page: currentPage - 1,
                totalCount,
              };
            } catch (err) {
              updateSummary([]);
              toast.error(t('toastify:commons.toast_error_api'));
              return { data: [] };
            }
          }}
          components={{
            search: true,
            title: true,
            Toolbar: (props) => (
              <div style={{ position: 'relative' }}>
                {disable && (
                  <div className={classes.message}>
                    <Typography variant="subtitle2" style={{ fontSize: 12 }}>
                      Acesse <a href="#" onClick={handleNotificationClick}>notificações</a> para fazer o download <br />
                      do seu relatório acadêmico.
                    </Typography>
                  </div>
                )}
                <MTableToolbar {...props} />
                {required && (
                  <CardContent style={{ marginBottom: 12, paddingBottom: 0 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={3}>
                        <Paper variant="outlined" className={classes.summaryCard}>
                          <Grid container justify="space-between" alignItems="center">
                            <Typography variant="subtitle2" className={classes.summaryTitle}>
                              Cursos Obrigatórios
                            </Typography>
                            <div className={classes.summaryIconBlue}>
                              <MenuBookOutlinedIcon className={classes.summaryIconSize} />
                            </div>
                          </Grid>
                          <div className={classes.summaryRatio}>
                            <Typography variant="h4" className={classes.summaryNumberBlue}>
                              {summary.requiredCourses.completed}
                            </Typography>
                            <Typography variant="h6" className={classes.summaryTotal}>
                              / {summary.requiredCourses.total}
                            </Typography>
                          </div>
                          <Grid container justify="space-between" alignItems="center" className={classes.summaryMetaRow}>
                            <Typography variant="body2" className={classes.summaryMetaText}>
                              Concluídos
                            </Typography>
                            <Typography variant="body2" className={classes.summaryMetaText}>
                              {getCompletionPercent(summary.requiredCourses.completed, summary.requiredCourses.total)}%
                            </Typography>
                          </Grid>
                          <div className={classes.progressTrack}>
                            <div
                              className={classes.progressBarBlue}
                              style={{
                                width: getCompletionPercent(summary.requiredCourses.completed, summary.requiredCourses.total) + '%',
                              }}
                            />
                          </div>
                        </Paper>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <Paper variant="outlined" className={classes.summaryCard}>
                          <Grid container justify="space-between" alignItems="center">
                            <Typography variant="subtitle2" className={classes.summaryTitle}>
                              Trilhas Obrigatórias
                            </Typography>
                            <div className={classes.summaryIconGreen}>
                              <DeviceHubOutlinedIcon className={classes.summaryIconSize} />
                            </div>
                          </Grid>
                          <div className={classes.summaryRatio}>
                            <Typography variant="h4" className={classes.summaryNumberGreen}>
                              {summary.trails.completed}
                            </Typography>
                            <Typography variant="h6" className={classes.summaryTotal}>
                              / {summary.trails.total}
                            </Typography>
                          </div>
                          <Grid container justify="space-between" alignItems="center" className={classes.summaryMetaRow}>
                            <Typography variant="body2" className={classes.summaryMetaText}>
                              Concluídos
                            </Typography>
                            <Typography variant="body2" className={classes.summaryMetaText}>
                              {getCompletionPercent(summary.trails.completed, summary.trails.total)}%
                            </Typography>
                          </Grid>
                          <div className={classes.progressTrack}>
                            <div
                              className={classes.progressBarGreen}
                              style={{
                                width: getCompletionPercent(summary.trails.completed, summary.trails.total) + '%',
                              }}
                            />
                          </div>
                        </Paper>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <Paper variant="outlined" className={classes.summaryCard}>
                          <Grid container justify="space-between" alignItems="center">
                            <Typography variant="subtitle2" className={classes.summaryTitle}>
                              Pessoas nas Trilhas
                            </Typography>
                            <div className={classes.summaryIconBlue}>
                              <GroupOutlinedIcon className={classes.summaryIconSize} />
                            </div>
                          </Grid>

                          <div className={classes.summaryRatio}>
                            <Typography variant="h4" className={classes.summaryNumberBlue}>
                              {summary.trailUsers.completed}
                            </Typography>
                            <Typography variant="h6" className={classes.summaryTotal}>
                              / {summary.trailUsers.total}
                            </Typography>
                          </div>
                          <Grid container justify="space-between" alignItems="center" className={classes.summaryMetaRow}>
                            <Typography variant="body2" className={classes.summaryMetaText}>
                              Concluíram trilhas
                            </Typography>
                            <Typography variant="body2" className={classes.summaryMetaText}>
                              {getCompletionPercent(summary.trailUsers.completed, summary.trailUsers.total)}%
                            </Typography>
                          </Grid>

                          <div className={classes.progressTrack}>
                            <div
                              className={classes.progressBarBlue}
                              style={{
                                width: getCompletionPercent(summary.trailUsers.completed, summary.trailUsers.total) + '%',
                              }}
                            />
                          </div>
                        </Paper>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <Paper variant="outlined" className={classes.summaryCard}>
                          <Grid container justify="space-between" alignItems="center">
                            <Typography variant="subtitle2" className={classes.summaryTitle}>
                              Progresso das Trilhas
                            </Typography>
                            <div className={classes.summaryIconGreen}>
                              <TrendingUpOutlinedIcon className={classes.summaryIconSize} />
                            </div>
                          </Grid>

                          <div className={classes.summaryRatio}>
                            <Typography variant="h4" className={classes.summaryNumberGreen}>
                              {summary.trailProgress.completed}
                            </Typography>
                            <Typography variant="h6" className={classes.summaryTotal}>
                              / {summary.trailProgress.total}
                            </Typography>
                          </div>

                          <Grid container justify="space-between" alignItems="center" className={classes.summaryMetaRow}>
                            <Typography variant="body2" className={classes.summaryMetaText}>
                              Matrículas concluídas
                            </Typography>
                            <Typography variant="body2" className={classes.summaryMetaText}>
                              {getCompletionPercent(summary.trailProgress.completed, summary.trailProgress.total)}%
                            </Typography>
                          </Grid>

                          <div className={classes.progressTrack}>
                            <div
                              className={classes.progressBarGreen}
                              style={{
                                width: getCompletionPercent(summary.trailProgress.completed, summary.trailProgress.total) + '%',
                              }}
                            />
                          </div>
                        </Paper>
                      </Grid>
                    </Grid>
                  </CardContent>
                )}
                <Divider />
                <form onSubmit={handleSubmit(onSubmit)}>
                  <CardContent>
                    <Grid container spacing={1} md={12}>
                      <Grid item md={4} xs={12} >
                        <TextField
                          fullWidth
                          label={t('form:commons.input_search')}
                          name="filter"
                          type="text"
                          variant="outlined"
                          defaultValue={filter || ''}
                          inputRef={register}
                        />
                      </Grid>
                      <Grid item md={2} xs={12}>
                        <FormControl style={{ minWidth: 130 }}>
                          <InputLabel id="status">
                            {t("form:commons.input_status")}
                          </InputLabel>
                          <Controller
                            as={
                              <Select>
                                <MenuItem value={1}>{t(statusUser[1]?.title)}</MenuItem>
                                <MenuItem value={2}>{t(statusUser[4]?.title)}</MenuItem>
                              </Select>
                            }
                            name="status"
                            control={control}
                            onChange={([event]) => handleChange(event.target.value)}
                            defaultValue={status}
                            value={status}
                          />
                        </FormControl>
                      </Grid>


                      <Grid item md={2} xs={12}>

                        <Grid item md={2} xs={12}>
                          <FormControl style={{ minWidth: 130 }}>
                            <InputLabel id="status3">
                              {t("form:commons.input_period_finished")}
                            </InputLabel>
                            <Controller
                              as={
                                <Select>
                                  <MenuItem value={1}>{t(statusPeriodFinished[1]?.title)}</MenuItem>
                                  <MenuItem value={2}>{t(statusPeriodFinished[2]?.title)}</MenuItem>
                                  <MenuItem value={3}>{t(statusPeriodFinished[3]?.title)}</MenuItem>
                                  <MenuItem value={5}>{t(statusPeriodFinished[5]?.title)}</MenuItem>
                                  <MenuItem value={6}>{t(statusPeriodFinished[6]?.title)}</MenuItem>
                                  <MenuItem value={7}>{t(statusPeriodFinished[7]?.title)}</MenuItem>
                                  <MenuItem value={4}>{t(statusPeriodFinished[4]?.title)}</MenuItem>
                                </Select>
                              }
                              name="periodFinished"
                              control={control}
                              onChange={([event]) => handlePeriodFinishedChange(event.target.value)}
                              defaultValue={periodFinished}
                              value={periodFinished}
                            />
                          </FormControl>
                        </Grid>

                      </Grid>


                      <Grid item md={4} xs={12} className={classes.actions}>
                        <Button
                          color="primary"
                          variant="contained"
                          size="large"
                          type="submit"
                        >
                          <Search className={classes.icon} />
                          {t('button:User_solictation.btn_advanced_filter')}
                        </Button>
                      </Grid>
                    </Grid>

                  </CardContent>
                </form>
              </div>
            ),
          }}
          localization={localizationTable(t)}
          actions={[
            {
              icon: () => (
                disableButton && (
                  <>
                    <Tooltip title={"Somente após o download de um relatório solicitado, é possível solicitar novamente ou aguarde alguns minutos que o botão será reativado."}>
                      <span>
                        <Button disabled={disable}>
                          <VerticalAlignBottom
                            handleFetch={() => handleFetch(status, periodFinished)}
                            onClick={() => customExport("excel")}
                            tableRef={tableRef}
                          />
                        </Button>
                      </span>
                    </Tooltip>
                  </>
                )
              ),
              isFreeAction: true,
            },
          ]}

          options={{
            ...options,
            exportButton: false,
            doubleHorizontalScroll: 'true',
            // maxBodyHeight: 530,
          }}
        />
      </div>
    </>
  );
};
